<woa-icon-library></woa-icon-library>
<woa-page-container [rootSelector]="'woa-entry-page'"></woa-page-container>
@if (configurationModel.testOverrideActive()) {
    <woa-watermark [text]="'woa.message.testOverrideWatermark' | translate"></woa-watermark>
} @else if (configurationModel.app() && !configurationModel.app()!.appLiveMode) {
    <woa-watermark [text]="'woa.message.testModeWatermark' | translate"></woa-watermark>
}
<woa-loading-spinner></woa-loading-spinner>
